import { render, staticRenderFns } from "./Settings.html?vue&type=template&id=ae22e344&scoped=true&external"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae22e344",
  null
  
)

export default component.exports